var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0207 11.0787L14.876 13.9333L13.9327 14.8767L11.078 12.0213C10.0159 12.8728 8.69471 13.3359 7.33337 13.334C4.02137 13.334 1.33337 10.646 1.33337 7.33398C1.33337 4.02198 4.02137 1.33398 7.33337 1.33398C10.6454 1.33398 13.3334 4.02198 13.3334 7.33398C13.3353 8.69532 12.8722 10.0165 12.0207 11.0787ZM10.6834 10.584C11.5294 9.71391 12.002 8.5476 12 7.33398C12 4.75598 9.91137 2.66732 7.33337 2.66732C4.75537 2.66732 2.66671 4.75598 2.66671 7.33398C2.66671 9.91198 4.75537 12.0007 7.33337 12.0007C8.54699 12.0026 9.7133 11.5301 10.5834 10.684L10.6834 10.584Z",
    fill: "#ACAAAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/Searchicon.aa26d1b1f984fbdd8e6b18b234cb2cb7.svg";
export { ForwardRef as ReactComponent };